<mat-accordion>

  <mat-expansion-panel [disabled]="!MenuExpandido" *ngFor="let item of menuList$ | async" [expanded]="item.expanded" [hideToggle]="!item.submenu?.length"
    class="u-text-white">
    <mat-expansion-panel-header [ngClass]="{ 
    'active-parent': item.expanded, 
    'collapsed-menu': !MenuExpandido 
  }">
      <div class="h-full w-10 u-bg-white"></div>
      <div (click)="menuSelecionadoFunc(item)" [routerLink]="item.submenu?.length ? null : item.page" class="flex flex-mobile u-gap-10">
        <i class="material-symbols-outlined">{{ item.icon }}</i>
        <span *ngIf="MenuExpandido" class="fw-400 u-fs-14">{{ item.title }}</span>
      </div>

    </mat-expansion-panel-header>

    <ng-container *ngIf="item.submenu?.length">
      <ul *ngIf="MenuExpandido">
        <li class="flex flex-mobile u-gap-10" [routerLink]="sub.page" (click)="expandirSomente(item)"
          *ngFor="let sub of item.submenu">
          <i class="material-symbols-outlined">{{ sub.icon }}</i>
          <a class="fw-400 u-fs-14">{{ sub.title }}</a>
        </li>

      </ul>
    </ng-container>
  </mat-expansion-panel>
</mat-accordion>